<template>
  <org-main @back="onCancel">
    <template slot="nav">
      <div class="UnitSet">
        <p>机构设置</p>
      </div>
    </template>
    <template slot="main">
      <!-- <vue-scroll :ops="ops">
        </vue-scroll> -->
      <div class="UnitMain">
        <template v-if="isShow">
          <vue-scroll :ops="ops">
          <div class="form_wrap">
            <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item label="机构全称" prop="name">
              <el-input v-model.trim="form.name" placeholder="请输入机构全称"></el-input>
            </el-form-item>
            <el-form-item label="机构简称" prop="org_abbreviation">
              <el-input v-model.trim="form.org_abbreviation" placeholder="请输入机构简称"></el-input>
            </el-form-item>
            <el-form-item label="机构所在省份或城市"
                          prop="province_id">
              <el-row v-if="showCity">
                <el-col :span="11">
                  <el-form-item prop="province_id">
                    <el-select v-model="form.province_id"
                               placeholder="请选择省份"
                               style="width: 100%;"
                               @change="updateCity" disabled>
                      <el-option
                          v-for="(item, index) in area"
                          :key="index"
                          :label="item.regionName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="2">&nbsp;</el-col>
                <el-col :span="11">
                  <el-form-item prop="city_id">
                    <el-select v-model="form.city_id"
                               placeholder="请选择城市"
                               style="width: 100%;" disabled>
                      <el-option
                          v-for="(item, index) in city"
                          :key="index"
                          :label="item.regionName"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item v-else
                            prop="province_id">
                <el-select v-model="form.province_id"
                           placeholder="请选择省份"
                           style="width: 100%;"
                           @change="updateCity" disabled>
                  <el-option
                      v-for="(item, index) in area"
                      :key="index"
                      :label="item.regionName"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form-item>
              <el-form-item label="执照分发方式" prop="license_distribute_way">
                <el-select v-model="form.license_distribute_way"
                  placeholder="请选择执照分发方式"
                  style="width: 100%;"
                  >
                  <el-option
                    v-for="(item, index) in distribute_way"
                    :key="index"
                    :label="item.key"
                    :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="机构地址" prop="address">
              <el-input v-model.trim="form.address" placeholder="请输入机构详细地址"></el-input>
            </el-form-item>
            <el-form-item label="机构电话" prop="tel_number">
              <el-input v-model.trim="form.tel_number" placeholder="请输入机构手机号或电话"></el-input>
            </el-form-item>
            <el-form-item label="机构传真" prop="org_fax">
              <el-input v-model.trim="form.org_fax" placeholder="请输入机构传真" ></el-input>
            </el-form-item>
              <el-form-item label="机构邮箱" prop="org_email">
                <el-input v-model.trim="form.org_email" placeholder="请输入机构邮箱" ></el-input>
              </el-form-item>
            <el-form-item label="官方微信公众号" prop="org_official_accounts">
              <el-input v-model.trim="form.org_official_accounts" placeholder="请输入官方微信公众号" ></el-input>
            </el-form-item>
            <div class="upload">
              <el-form-item label="机构LOGO" prop="image_url" class="up-form-item">
              <div class="upfile-wrap">
                <image-up
                    :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
                    :lw="'130px'"
                    :lh="'130px'"
                    :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
                    :imgval.sync="form.image_url"
                    :cover='showImg'
                    :default-img="org_logo"
                    :dt="'12vh'"
                ></image-up>
                <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
              </div>
            </el-form-item>
              <el-form-item label="官方微信公众号二维码" prop="org_qr_code" class="up-form-item" label-width="180px">
              <div class="upfile-wrap">
                <image-up
                    :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
                    :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
                    :imgval.sync="form.org_qr_code"
                    :cover='showCode'
                    :lw="'130px'"
                    :lh="'130px'"
                    :default-img="org_logo"
                    :dt="'12vh'"
                ></image-up>
                <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
              </div>
            </el-form-item>
            </div>
          </el-form>
          </div>
          </vue-scroll>

          <div class="btns">
            <el-button type="primary" :loading="repeatSubmit"  @click="onSubmit">保存</el-button>
            <el-button type="danger" @click="onCancel">取消</el-button>
          </div>
        </template>
      </div>


      <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
      <yioks-tips :showTips="tipsFlag"
        :tips="'确定放弃修改并返回吗？'"
        @hideTips="hideTipsDialog"></yioks-tips>
    </template>

  </org-main>
</template>

<script>
  import Main from "@/components/LayOut/Common/up-down";
  import {area_list, area_name} from "@/assets/js/region";
  import {licenseDistributeWay} from "@/assets/js/select";
  import {orgDetailInfo} from "@/api/common/api";
  import {orgSet} from "@/api/setting/api";
  import org_logo from "@/assets/images/org_logo.png";
  import {mapActions} from "vuex";
  import ops from "@/assets/js/vuescrollOption";
  const HOSTURL = process.env.VUE_APP_URL;

  export default {
    name: "UnitSet",
    props: ["visible"],
    data() {
      return {
        repeatSubmit: false,
        org_logo,
        // 保存回显的用户头像
        showImg: null,
        showCode:null,
        isShow: false,
        showCity: false,
        tipsFlag: false,
        area: area_list,
        distribute_way: licenseDistributeWay,
        city: [],
        info: {},
        ops:ops(),
        form: {
          name: "",
          org_abbreviation: "",
          province_id: "",
          city_id: "",
          address: "",
          tel_number: "",
          image_url: "",
          org_official_accounts:'',
          org_fax:'',
          org_qr_code:'',
          license_distribute_way:'',
          org_email:''
        },
        rules: {
          name: [
            {required: true, message: '请输入机构全称', trigger: 'blur'},
          ],
          org_abbreviation: [
            {required: true, message: '请输入机构简称', trigger: 'blur'},
          ],
          province_id: [
            {required: true, message: '请选择机构所在省', trigger: 'change'}
          ],
          city_id: [
            {required: true, message: '请选择机构所在市', trigger: 'change'}
          ],
          license_distribute_way: [
            {required: true, message: '请选择执照分发方式', trigger: 'change'}
          ],
          tel_number: [
            {
              required: false,
              validator: (rule, val, callback) => {
                if (val == '' || val == null) {
                  callback();
                }
                if (this.$yioks.phone(val)) {
                  if (!this.phone_flag) {
                    callback();
                  } else {
                    this.phone_flag = false;
                    callback(new Error(this.phone_msg));
                  }
                } else {
                  callback(new Error('11位手机号或固定电话(格式:0371-6778****)'));
                }
              },
              trigger: "blur"
            }
          ]
        }
      }
    },
    components: {
      "org-main": Main,
      "image-up": () => import("@/components/UpImage/UpImage"),
      "yioks-tips": () => import("@/components/Tips/Dialog")
    },
    computed: {
      flag: {
        set(bool) {
          this.resetForm();
        },
        get() {
          return this.visible;
        },
      }
    },
    created() {
      this.UnitformData();
    },
    methods: {
      ...mapActions(["actionStoreOrgData"]),
      UnitformData() {
        /* 是否显示 城市 */
        orgDetailInfo({})
          .then(res => {
            // console.log(res);
            const {msg, status, result} = res.data;
            if (Number(status) === 0) {
              this.info = result.organization_info;
              this.$set(this.form, "name", this.info.name);
              this.$set(this.form, "org_abbreviation", this.info.org_abbreviation);
              this.$set(this.form, "province_id", this.info.province_id.toString());
              this.$set(this.form, "city_id", this.info.city_id.toString());
              this.$set(this.form, "address", this.info.address);
              this.$set(this.form, "org_fax", this.info.org_fax);
              this.$set(this.form, "org_email", this.info.org_email);
              this.$set(this.form, "org_official_accounts", this.info.org_official_accounts);
              this.$set(this.form, "tel_number", this.info.tel_number);
              this.$set(this.form, "image_url", this.info.profile_picture === '' ? "" : this.info.profile_picture);
              this.$set(this.form, "org_qr_code", this.info.org_qr_code === '' ? "" : this.info.org_qr_code);
              this.$set(this.form, "license_distribute_way", this.info.license_distribute_way);
              this.showImg = this.info.profile_picture && HOSTURL + this.info.profile_picture;

              this.showCode=this.info.org_qr_code  && HOSTURL + this.info.org_qr_code;
              this.showCity = Boolean(this.info.org_level === "city");
              if (this.showCity) {
                this.updateCity(false);
              }
              this.isShow = true;
              // console.log(this.form.image_url);
            } else {
              this.$message.error("机构信息异常~");
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      updateCity() {
        this.city = this.$yioks.updateCity(this.form.province_id, this.area);
        if (this.form.org_level === "city") {
          this.$set(this.form, "city_id", this.city[0].id);
        }
      },
      resetForm() {
        this.$refs["form"].resetFields();
      },
      onSubmit() {
        if(this.repeatSubmit){return;}
        this.repeatSubmit = true;
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const data = this.form;
            if (this.form.image_url === this.info.profile_picture) {
              delete  data.image_url;
            }if (this.form.org_qr_code === this.info.org_qr_code) {
              delete  data.org_qr_code;
            }
            orgSet(data)
              .then(res => {
                const {status} = res.data;
                // console.log(res);
                if (Number(status) === 0) {
                  this.actionStoreOrgData()
                    .then(() => {
                      this.$message.success("机构设置修改成功~");
                      this.$router.push({name: "Organization"});
                      this.repeatSubmit = false;
                    })
                    .catch(err => {
                      this.repeatSubmit = false;
                      console.error(err);
                    })
                } else {
                  this.$message.error("机构设置修改失败，请稍后重试~");
                  this.repeatSubmit = false;
                }
              })
              .catch(err => {
                this.repeatSubmit = false;
                console.error(err);
              });

            // alert('submit!');
          } else {
            this.repeatSubmit = false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      onCancel() {
        console.log('onCancel');
        this.tipsFlag = true;
      },
      hideTipsDialog(bool, sure) {
        this.tipsFlag = bool;
        if (sure) {
          //this.$router.push({name: "Organization"});
          this.$router.go(-1);
        } else {

        }
      }
    }
  }

</script>
<style lang="stylus">
  @import '~@/assets/css/variable'
  .UnitMain .el-form-item {
    margin-bottom: 30px;
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .UnitMain {
    .el-form-item__label {
      color: $color_white;
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .UnitSet, .UnitMain {
    flex: 1 1 auto;
  }

  .UnitSet {
    display: flex;
    align-items: center;
    font-size: $font_size_big;
  }

  .UnitMain {
    width: 100%;
    height 90%
    background-color: $block_bg_color_base;
    padding: 40px 0 0px 30px;
    .form_wrap{
      padding-right 40px
    }
    .up-form-item {
      .upfile-wrap {
        display: block;
        .tip {
          display: block;
          font-size: $font_size_base;
          line-height: 30px;
        }
      }
    }

    .btns {
      display: flex;
       justify-content: center;
       color: $color_white;
      .el-button--danger {
        background-color $color_err
      }

    }
  }
.upload{
  display flex
  // justify-content center
}
.btns {
      display: flex;
      justify-content: center;
      padding-top  20px
      margin-right 50px
      .el-button--danger {
        background-color $color_err
      }
}
</style>



